import React from 'react'

import { arrayOf, shape, string } from 'prop-types'

import assetLibrarySmallImage from 'images/discover/business_account/asset-library-500.webp'
import assetLibraryImage from 'images/discover/business_account/asset-library.avif'
import checkImage from 'images/discover/business_account/check.svg'
import licensingTermsSmallImage from 'images/discover/business_account/licensing-terms-500.webp'
import licensingTermsImage from 'images/discover/business_account/licensing-terms.avif'
import paymentsSmallImage from 'images/discover/business_account/payments-500.webp'
import paymentsImage from 'images/discover/business_account/payments.avif'
import sharingSmallImage from 'images/discover/business_account/sharing-500.webp'
import sharingImage from 'images/discover/business_account/sharing.avif'

const FEATURE_IMAGES = [
  { src: assetLibraryImage, smallSrc: assetLibrarySmallImage, width: 1118, height: 820 },
  { src: licensingTermsImage, smallSrc: licensingTermsSmallImage, width: 1131, height: 834 },
  { src: paymentsImage, smallSrc: paymentsSmallImage, width: 1047, height: 744 },
  { src: sharingImage, smallSrc: sharingSmallImage, width: 1126, height: 788 },
]

function Features({ features }) {
  return (
    <section className="business-account-features">
      <div className="discover-container">
        {features.map((feature, index) => {
          const image = FEATURE_IMAGES[index]
          const isImageFirst = index % 2 === 1
          const contentModifier = isImageFirst ? ' business-account-features__content--end' : ''
          const imageModifier = isImageFirst ? ' business-account-features__image--start' : ''

          return (
            <div key={feature.title} className="business-account-features__item">
              <div className={`business-account-features__content${contentModifier}`}>
                <h2 className="discover-heading cgt-heading-400">{feature.title}</h2>
                <p className="business-account-features__description cgt-body-md">{feature.description}</p>
                <div className="business-account-features__checklist">
                  {feature.subtitle && (
                    <p className="business-account-features__subtitle cgt-body-md-semibold">{feature.subtitle}</p>
                  )}
                  <ul className="business-account-features__checks">
                    {feature.checks.map(check => (
                      <li key={check} className="business-account-features__check cgt-body-md">
                        <img
                          src={checkImage}
                          alt=""
                          width={24}
                          height={24}
                          className="business-account-features__check-icon"
                        />
                        {check}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <img
                src={image.src}
                srcSet={`${image.smallSrc} 500w, ${image.src} ${image.width}w`}
                sizes="(max-width: 639px) 100vw, 560px"
                alt={feature.imageAlt}
                width={image.width}
                height={image.height}
                loading="lazy"
                className={`business-account-features__image${imageModifier}`}
              />
            </div>
          )
        })}
      </div>
    </section>
  )
}

Features.propTypes = {
  features: arrayOf(shape({
    title: string.isRequired,
    description: string.isRequired,
    subtitle: string,
    checks: arrayOf(string).isRequired,
    imageAlt: string.isRequired,
  })).isRequired,
}

export default Features
